import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import _MenuOutlined from "@ant-design/icons/lib/icons/MenuOutlined";
import "antd/lib/drawer/style";
import _Drawer from "antd/lib/drawer";
import "antd/lib/badge/style";
import _Badge from "antd/lib/badge";
import _asyncToGenerator from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/menu/style";
import _Menu from "antd/lib/menu";
import _defineProperty from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
import "antd/lib/layout/style";
import _Layout from "antd/lib/layout";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { AngleDownIcon, BellIcon } from 'react-line-awesome';
import * as Sentry from '@sentry/nextjs';
import { Client } from '@twilio/conversations';
import { subMinutes } from 'date-fns';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import Head from 'next/head';
import Link from 'next/link';
import Router from 'next/router';
import { clearCookies, getTwilioToken, logOut, resetUserInfoCookie, setAuthorizationHeader } from '@gtintel/platform-api';
import { countUnreadMessages } from '@gtintel/platform-chat';
import { ADMIN_AVATAR, ADMIN_ROLE, CLIENT_ROLE, COOKIE_NAMES, DEFAULT_AVATAR, PARTNER_ROLE, ROUTES, TWILIO_ADMIN_IDENTITY } from '@gtintel/platform-constants';
import { FeaturesContext } from '@gtintel/platform-context';
import firebase, { FirebaseAppsEnum } from '@gtintel/platform-firebase';
import { UserRole } from '@gtintel/platform-types';
import { clearSessionStorage, getSessionStorageItem, removeSessionStorageItem, setCookie, setSessionStorageItem } from '@gtintel/platform-utils';
import AvatarName from '../widgets/AvatarName';
import { HorizontalMenu } from './styles';
var ADMIN_COLOR = '#D0021B';
var CLIENT_COLOR = '#FFBA00';
var PARTNER_COLOR = '#4D7CFE';
var Header = _Layout.Header,
  Content = _Layout.Content,
  Footer = _Layout.Footer;
var Text = _Typography.Text;
var menuAdmin = [{
  key: 1,
  name: 'Dashboard',
  router: ROUTES.ADMIN_DASHBOARD
}, {
  key: 2,
  name: 'Users',
  router: ROUTES.ADMIN_USER
}, {
  key: 3,
  name: 'Tags',
  router: ROUTES.ADMIN_TAG
}, {
  key: 4,
  name: 'Projects',
  router: ROUTES.ADMIN_PROJECT
}, {
  key: 6,
  name: 'Batch Requests',
  router: ROUTES.ADMIN_BatchRequests
}, {
  key: 5,
  name: 'Messages',
  router: ROUTES.ADMIN_MESSAGE
}];
var menuClient = [{
  key: 1,
  name: 'Dashboard',
  router: ROUTES.CLIENT_DASHBOARD
}, {
  key: 2,
  name: 'My Account',
  router: ROUTES.CLIENT_MY_ACCOUNT
}, {
  key: 4,
  name: 'Projects',
  router: ROUTES.CLIENT_PROJECT
}, {
  key: 5,
  name: 'Messages',
  router: ROUTES.CLIENT_MESSAGE
}];
var assignmentsMenu = {
  key: 6,
  name: 'Assignments',
  router: ROUTES.PARTNER_ASSIGNMENT
};
var menuPartner = [{
  key: 1,
  name: 'Dashboard',
  router: ROUTES.PARTNER_DASHBOARD
}, {
  key: 2,
  name: 'My Account',
  router: ROUTES.PARTNER_PROFILE
}, {
  key: 4,
  name: 'Projects',
  router: ROUTES.PARTNER_PROJECT
}, {
  key: 5,
  name: 'Messages',
  router: ROUTES.PARTNER_MESSAGE
}];
var requestMenuItem = {
  key: 7,
  name: 'Requests',
  router: ROUTES.PARTNER_REQUESTS_HOME
};
var AppLayout = /*#__PURE__*/function (_Component) {
  _inherits(AppLayout, _Component);
  var _super = _createSuper(AppLayout);
  function AppLayout() {
    var _this;
    _classCallCheck(this, AppLayout);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.client = void 0;
    _this.state = {
      type_view: null,
      avatar: null,
      first_name: null,
      is_administrator: null,
      is_client: null,
      is_network_partner: null,
      last_name: null,
      username: null,
      collapsed: false,
      color: null,
      dual_account: null,
      unreadMessageCount: 0,
      identity: null,
      admin: {
        listChannel: []
      },
      featureSwitch: {
        sso_login_page: null
      }
    };
    _this.renderFirstData = function () {
      var token = Cookies.get(COOKIE_NAMES.TOKEN);
      var user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
      var type_view = getSessionStorageItem(COOKIE_NAMES.TYPE_VIEW);
      var sessionId = sessionStorage.getItem('session_id');
      if (_this.state.featureSwitch.sso_login_page === 'on') {
        if (!user || !type_view) {
          clearCookies();
          clearSessionStorage();
          Router.push(ROUTES.LOGIN_PAGE)["catch"](function () {});
        }
      } else {
        if (!token && !sessionId || !user || !type_view) {
          clearCookies();
          clearSessionStorage();
          Router.push(ROUTES.LOGIN_PAGE)["catch"](function () {});
        }
      }
      var pathName = '';
      switch (type_view) {
        case ADMIN_ROLE:
          pathName = '/admin/';
          break;
        case CLIENT_ROLE:
          pathName = '/client/';
          break;
        case PARTNER_ROLE:
          pathName = '/partner/';
          break;
      }
      if (!window.location.href.includes(pathName)) {
        clearCookies();
        clearSessionStorage();
        Router.push(ROUTES.LOGIN_PAGE);
      }
      if (user) {
        var projects = firebase.apps[FirebaseAppsEnum.GTIDev].database().ref(user !== null && user !== void 0 && user.is_administrator ? TWILIO_ADMIN_IDENTITY : String(user === null || user === void 0 ? void 0 : user.id)).orderByChild('noti_badge').equalTo(false);
        projects.on('value', function (snapshot) {
          var projectsNotification = snapshot.numChildren();
          _this.setState({
            projectsNotification: projectsNotification,
            value: snapshot.val()
          });
        });
        var messages = firebase.apps[FirebaseAppsEnum.GTIMessagingDev].database().ref(user !== null && user !== void 0 && user.is_administrator ? TWILIO_ADMIN_IDENTITY : String(user === null || user === void 0 ? void 0 : user.id)).orderByChild('read').equalTo(false);
        messages.on('value', function (snapshot) {
          var messagesNotification = snapshot.numChildren();
          _this.setState({
            messagesNotification: messagesNotification
          });
        });
        user.identity = user.id;
        if (user !== null && user !== void 0 && user.is_administrator) {
          user.identity = TWILIO_ADMIN_IDENTITY;
        }
        _this.setTwilioToken(user);
        _this.setState(_objectSpread(_objectSpread({}, user), {}, {
          type_view: type_view
        }));
        _this.setColor(type_view);
      }
      if (_this.context.viewRequestsPage === 'on') {
        if (!menuPartner.includes(requestMenuItem)) {
          menuPartner.push(requestMenuItem);
        }
      }
      if (menuPartner[3] !== assignmentsMenu) {
        menuPartner.splice(3, 0, assignmentsMenu);
      }
    };
    _this.toggle = function () {
      // @ts-ignore
      _this.setState(function (prevState) {
        return {
          collapsed: !prevState.collapsed
        };
      });
    };
    _this.onClose = function () {
      _this.setState({
        collapsed: false
      });
    };
    _this.userList = function () {
      var _this$state = _this.state,
        avatar = _this$state.avatar,
        last_name = _this$state.last_name,
        first_name = _this$state.first_name,
        is_administrator = _this$state.is_administrator,
        type_view = _this$state.type_view,
        is_client = _this$state.is_client,
        is_network_partner = _this$state.is_network_partner,
        dual_account = _this$state.dual_account;
      var linkProfile = '';
      var user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
      if (type_view === ADMIN_ROLE) {
        linkProfile = '/admin';
      }
      if (type_view === CLIENT_ROLE) {
        linkProfile = '/client';
      }
      if (type_view === PARTNER_ROLE) {
        linkProfile = '/partner';
      }
      var userAvatar = avatar !== null && avatar !== void 0 ? avatar : is_administrator ? ADMIN_AVATAR : DEFAULT_AVATAR;
      return __jsx(_Menu, {
        className: "user-menu"
      }, !is_administrator && dual_account && !is_client && type_view !== CLIENT_ROLE && type_view !== ADMIN_ROLE ? __jsx(_Menu.Item, {
        key: "1",
        onClick: function onClick() {
          _this.changeRole(CLIENT_ROLE, 'client', ROUTES.CLIENT_DASHBOARD);
        }
      }, __jsx("div", {
        className: "menu-user-item"
      }, __jsx(AvatarName, {
        avatar: userAvatar,
        name: "".concat(first_name !== null && first_name !== void 0 ? first_name : '', " ").concat(last_name !== null && last_name !== void 0 ? last_name : ''),
        role: CLIENT_ROLE,
        color: CLIENT_COLOR
      }))) : null, !is_administrator && dual_account && !is_network_partner && type_view !== PARTNER_ROLE && type_view !== ADMIN_ROLE ? __jsx(_Menu.Item, {
        key: "2",
        onClick: function onClick() {
          _this.changeRole(PARTNER_ROLE, 'partner', ROUTES.PARTNER_DASHBOARD);
        }
      }, __jsx("div", {
        className: "menu-user-item"
      }, __jsx(AvatarName, {
        avatar: userAvatar,
        name: "".concat(first_name !== null && first_name !== void 0 ? first_name : '', " ").concat(last_name !== null && last_name !== void 0 ? last_name : ''),
        role: PARTNER_ROLE,
        color: PARTNER_COLOR
      }))) : null, __jsx(_Menu.Item, {
        key: "Editprofile"
      }, __jsx(Link, {
        href: "".concat(linkProfile, "/profile/").concat(user ? user === null || user === void 0 ? void 0 : user.id : ''),
        legacyBehavior: true
      }, __jsx("div", {
        className: "menu-user-item"
      }, __jsx("a", {
        "data-public": true,
        "data-testid": "edit-profile-menu-link",
        className: "ant-typography"
      }, "Edit profile")))), ((user === null || user === void 0 ? void 0 : user.partner_role) === String(UserRole['Billing Admin']) || (user === null || user === void 0 ? void 0 : user.role) === String(UserRole['Billing Admin'])) && (user === null || user === void 0 ? void 0 : user.team) && __jsx(_Menu.Item, {
        key: "BillingInformation"
      }, __jsx(Link, {
        href: "".concat(linkProfile, "/profile/").concat(user ? user === null || user === void 0 ? void 0 : user.id : '', "?activeTab=4"),
        legacyBehavior: true
      }, __jsx("div", {
        className: "menu-user-item"
      }, __jsx("a", {
        "data-public": true,
        "data-testid": "edit-profile-menu-link",
        className: "ant-typography"
      }, "Billing information")))), __jsx(_Menu.Item, {
        key: "logout"
      }, __jsx(Link, {
        href: "#",
        legacyBehavior: true
      }, __jsx("div", {
        onClick: function onClick() {
          _this.logout();
        },
        className: "menu-user-item "
      }, __jsx("a", {
        "data-public": true,
        "data-testid": "logout-menu-link",
        className: "ant-typography"
      }, "Logout")))));
    };
    return _this;
  }
  _createClass(AppLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderFirstData();
    }
  }, {
    key: "setTwilioToken",
    value: function setTwilioToken() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var twilioToken = getSessionStorageItem(COOKIE_NAMES.TWILIO_USER_TOKEN);
      if (twilioToken && twilioToken !== 'undefined') {
        var tokenDecode = jwtDecode(twilioToken);
        if (tokenDecode.grants.identity === (user === null || user === void 0 ? void 0 : user.identity) && new Date() < subMinutes(new Date(tokenDecode.exp * 1000), 4)) {
          this.getChatClient(twilioToken);
        } else {
          this.refreshToken();
        }
      } else {
        this.refreshToken();
      }
    }
  }, {
    key: "refreshToken",
    value: function refreshToken() {
      var _this2 = this;
      getTwilioToken().then(function (data) {
        setSessionStorageItem(COOKIE_NAMES.TWILIO_USER_TOKEN, data.token);
        _this2.getChatClient(data.token);
      });
    }
  }, {
    key: "refreshUnreadMessageCount",
    value: function () {
      var _refreshUnreadMessageCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var count, page, unreadMessageCount;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.client) {
                  _context.next = 3;
                  break;
                }
                this.setState({
                  unreadMessageCount: 0
                });
                return _context.abrupt("return");
              case 3:
                count = function count(convs) {
                  return convs.map(countUnreadMessages).reduce(function (a, b) {
                    return a + b;
                  }, 0);
                };
                _context.next = 6;
                return this.client.getSubscribedConversations();
              case 6:
                page = _context.sent;
                unreadMessageCount = count(page.items);
              case 8:
                if (!page.hasNextPage) {
                  _context.next = 15;
                  break;
                }
                _context.next = 11;
                return page.nextPage();
              case 11:
                page = _context.sent;
                unreadMessageCount += count(page.items);
                _context.next = 8;
                break;
              case 15:
                this.setState({
                  unreadMessageCount: unreadMessageCount
                });
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function refreshUnreadMessageCount() {
        return _refreshUnreadMessageCount.apply(this, arguments);
      }
      return refreshUnreadMessageCount;
    }()
  }, {
    key: "getChatClient",
    value: function getChatClient(twilioToken) {
      var _this3 = this;
      var user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
      if (user) {
        user.identity = user === null || user === void 0 ? void 0 : user.id;
        if (user !== null && user !== void 0 && user.is_administrator) {
          user.identity = TWILIO_ADMIN_IDENTITY;
        }
        var transaction = Sentry.startTransaction({
          name: '/components/AppLayout/index.js Twilio'
        });
        var sentrySpan = transaction.startChild({
          op: 'new Client'
        });
        this.client = new Client(twilioToken);
        this.client.on('tokenAboutToExpire', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var token;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return getTwilioToken();
                case 2:
                  token = _context2.sent;
                  _this3.client.updateToken(token)["catch"](function () {});
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))).on('messageAdded', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(res) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this3.setState({
                      unreadMessageCount: 0
                    });
                    if ((user === null || user === void 0 ? void 0 : user.identity) !== res.author) {
                      _this3.refreshUnreadMessageCount();
                    }
                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()).on('connectionStateChanged', /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(state) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (state === 'connected') {
                      sentrySpan.setStatus('ok');
                      sentrySpan.finish();
                      _this3.refreshUnreadMessageCount();
                    } else if (state === 'denied') {
                      sentrySpan.setStatus('unknown_error');
                      sentrySpan.finish();
                      Cookies.remove(COOKIE_NAMES.TWILIO_USER_TOKEN);
                      removeSessionStorageItem(COOKIE_NAMES.TWILIO_USER_TOKEN);
                      _this3.setTwilioToken();
                    }
                    transaction.finish();
                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }()).on('conversationUpdated', /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4) {
            var conversation, message;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    conversation = _ref4.conversation;
                    _context5.next = 3;
                    return conversation.getMessages(1);
                  case 3:
                    message = _context5.sent;
                    if (message.items[0] && message.items[0].author !== (user === null || user === void 0 ? void 0 : user.identity)) {
                      _this3.refreshUnreadMessageCount();
                    }
                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));
          return function (_x3) {
            return _ref5.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "setColor",
    value: function setColor(type_view) {
      switch (type_view) {
        case ADMIN_ROLE:
          this.setState({
            color: ADMIN_COLOR
          });
          break;
        case CLIENT_ROLE:
          this.setState({
            color: CLIENT_COLOR
          });
          break;
        case PARTNER_ROLE:
          this.setState({
            color: PARTNER_COLOR
          });
          break;
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      logOut().then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                clearCookies();
                clearSessionStorage();
                Router.push(ROUTES.LOGIN_PAGE);
              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      })));
      clearCookies();
      clearSessionStorage();
      Router.push(ROUTES.LOGIN_PAGE)["catch"](function () {});
    }
  }, {
    key: "changeRole",
    value: function changeRole(type_select, _roleSelect, link) {
      var authtoken, reftoken;
      var user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
      var sessionId = sessionStorage.getItem('session_id');
      switch (type_select) {
        case CLIENT_ROLE:
          user.id = user.id_client;
          user.is_client = true;
          user.is_network_partner = false;
          authtoken = Cookies.get(COOKIE_NAMES.CLIENT_TOKEN);
          reftoken = Cookies.get(COOKIE_NAMES.CLIENT_REFRESH);
          break;
        case COOKIE_NAMES.ROLE_PARTNER:
          user.id = user.id_partner;
          user.is_client = false;
          user.is_network_partner = true;
          authtoken = Cookies.get(COOKIE_NAMES.NP_TOKEN);
          reftoken = Cookies.get(COOKIE_NAMES.NP_REFRESH);
          break;
      }
      if (!sessionId) {
        setCookie(COOKIE_NAMES.TOKEN, authtoken);
        setCookie(COOKIE_NAMES.REFRESH_TOKEN, reftoken);
        setSessionStorageItem(COOKIE_NAMES.TYPE_VIEW, type_select);
        setAuthorizationHeader(authtoken);
      }
      resetUserInfoCookie(user);
      Cookies.remove(COOKIE_NAMES.TWILIO_USER_TOKEN);
      this.setTwilioToken();
      this.setState({
        type_view: type_select
      });
      this.setColor(type_select);
      Router.push(link)["catch"](function () {});
    }
  }, {
    key: "renderMenu",
    value: function renderMenu(item, index, length) {
      var unreadMessageCount = index === length - 1 ? this.state.unreadMessageCount : null;
      var router = item.router;
      if (item.router === ROUTES.PARTNER_PROFILE) {
        router = ROUTES.PARTNER_PROFILE + '/' + this.state.identity;
      }
      return __jsx(_Menu.Item, {
        "data-public": true,
        "data-testid": "menu-button-".concat(item.name.toLowerCase().replace(/\s/g, '')),
        key: item.key,
        onClick: function onClick() {
          return Router.push(router);
        }
      }, __jsx(_Badge, {
        count: unreadMessageCount,
        offset: [-2, 0]
      }, item.name));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
        _this$state$messagesN,
        _this$state$projectsN;
      // @ts-ignore
      var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children,
        className = _this$props.className,
        menuSelected = _this$props.menuSelected,
        pageHeader = _this$props.pageHeader;
      var collapsed = this.state.collapsed;
      var _this$state2 = this.state,
        avatar = _this$state2.avatar,
        last_name = _this$state2.last_name,
        first_name = _this$state2.first_name,
        type_view = _this$state2.type_view,
        color = _this$state2.color,
        is_administrator = _this$state2.is_administrator;
      this.state.featureSwitch = this.context;
      var menu = [];
      if (type_view === ADMIN_ROLE) {
        menu = menuAdmin;
      } else if (type_view === CLIENT_ROLE) {
        menu = menuClient;
      } else if (type_view === PARTNER_ROLE) {
        menu = menuPartner;
      }
      var userAvatar = avatar !== null && avatar !== void 0 ? avatar : is_administrator ? ADMIN_AVATAR : DEFAULT_AVATAR;
      return __jsx(_Layout, null, __jsx(Head, null, __jsx("title", null, title || ''), __jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
      })), __jsx(_Drawer, {
        title: "Menu",
        placement: "left",
        closable: false,
        onClose: this.onClose,
        visible: collapsed,
        className: "drawer-dark"
      }, __jsx(_Menu, {
        theme: "dark",
        mode: "inline",
        defaultSelectedKeys: menuSelected !== null && menuSelected !== void 0 ? menuSelected : []
      }, menu.map(function (item) {
        return _this4.renderMenu(item);
      }))), __jsx(Header, {
        className: "layout-fix-header"
      }, /*#__PURE__*/React.createElement(_MenuOutlined, {
        className: 'trigger menu-mobile-icon',
        onClick: this.toggle
      }), __jsx("div", {
        className: "logo"
      }, __jsx(Link, {
        href: type_view === ADMIN_ROLE ? ROUTES.ADMIN_DASHBOARD : type_view === CLIENT_ROLE ? ROUTES.CLIENT_DASHBOARD : ROUTES.PARTNER_DASHBOARD
      }, __jsx("img", {
        src: "/images/GTI_Logo_Light.png",
        alt: "GTI logo",
        srcSet: "/images/GTI_Logo_Light@2x.png 2x",
        className: "logo-full"
      }), __jsx("img", {
        src: "/images/GTI_Logo_Mini.png",
        srcSet: "/images/GTI_Logo_Mini@2x.png 2x",
        alt: "GTI logo mini",
        className: "logo-mini"
      }))), __jsx(HorizontalMenu, {
        theme: "dark",
        mode: "horizontal",
        defaultSelectedKeys: menuSelected !== null && menuSelected !== void 0 ? menuSelected : []
      }, menu.map(function (item, i) {
        return _this4.renderMenu(item, i, menu.length);
      })), __jsx(_Row, {
        justify: "end",
        align: "middle"
      }, __jsx("div", {
        className: "header-icon-wrap"
      }, __jsx(_Row, null, __jsx(_Col, null, __jsx(_Badge, {
        count:
        // @ts-ignore
        ((_this$state$messagesN = this.state.messagesNotification) !== null && _this$state$messagesN !== void 0 ? _this$state$messagesN : 0) + (// @ts-ignore
        (_this$state$projectsN = this.state.projectsNotification) !== null && _this$state$projectsN !== void 0 ? _this$state$projectsN : 0),
        offset: [-2, 2]
      }, __jsx(Link, {
        href: type_view === ADMIN_ROLE ? ROUTES.ADMIN_NOTIFICATION : type_view === CLIENT_ROLE ? ROUTES.CLIENT_NOTIFICATION : ROUTES.PARTNER_NOTIFICATION
      }, __jsx(BellIcon, {
        component: "span",
        className: "notify-icon"
      })))))), __jsx(_Dropdown, {
        "data-public": true,
        overlay: this.userList()
      }, __jsx("a", {
        className: "header-avatar-wrap ant-dropdown-link avatar-header"
      }, __jsx(_Row, {
        "data-testid": "avatar-dropdown",
        align: "middle"
      }, __jsx(AvatarName, {
        avatar: userAvatar,
        name: "".concat(first_name !== null && first_name !== void 0 ? first_name : '', " ").concat(last_name !== null && last_name !== void 0 ? last_name : ''),
        role: type_view !== null && type_view !== void 0 ? type_view : '',
        color: color !== null && color !== void 0 ? color : ''
      }), __jsx(AngleDownIcon, {
        style: {
          fontWeight: 'bold'
        }
      })))))), pageHeader ? pageHeader : '', __jsx(Content, {
        className: "".concat(className, " main-content")
      }, __jsx("div", {
        className: "site-layout-content"
      }, children)), __jsx(Footer, {
        style: {
          opacity: 0.65
        }
      }, __jsx(Text, {
        className: "text-blue-light"
      }, "\xA9 ", new Date().getFullYear(), " Ground Truth Holdings Ltd - All Rights Reserved.")));
    }
  }], [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // @ts-ignore
                this.renderFirstData();
              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function getInitialProps() {
        return _getInitialProps.apply(this, arguments);
      }
      return getInitialProps;
    }()
  }]);
  return AppLayout;
}(Component);
AppLayout.contextType = FeaturesContext;
export default AppLayout;